import type { FaireProductEntity } from "../../entity_types/product";

export const p_88y5aep6nf: FaireProductEntity = {
  token: "p_88y5aep6nf",
  type: "product",
  name: "The Animal Love Grip Sock",
  brandToken: "b_3yhucboxcl",
  brandName: "LUCKY HONEY",
  imageUrl:
    "https://cdn.faire.com/fastly/b60cdb5dde950b05eaf4949151effad912a50e4babee6aa416aa6531bb147915.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce928f1cd5d928c30badaf05b1bfcbbfa50e804991cfd35a4e17f4ce7e4f528f.png",
    "https://cdn.faire.com/fastly/d84ca21e585b9fc146a04076e5937c0ec5ecfb0100587ad2ae29f413532d5762.png",
    "https://cdn.faire.com/fastly/054a5cc7d0463ca95f283561aaa49510ff44589fa65f66a12bbd87f97f8461da.png",
    "https://cdn.faire.com/fastly/22a0b6220245e9dc1cbaa301e87ef41531a7c3681891669e48c14fd3e29a4d3f.png",
    "https://cdn.faire.com/fastly/2d16e17eb4b36787400a7c49b4085ded746c22edf14ad38fd9708b2c93e775bc.png",
    "https://cdn.faire.com/fastly/40641a791024a21bc772686c147900c8e9b94f6e1c7567cf1c4d60dcc4a67d24.png",
    "https://cdn.faire.com/fastly/3d8fcdebe6a62827602cd823760575f4a4acc20c7b84ca5fb33a032da28ce091.png",
  ],
  priceDollars: 9,
  description:
    "The Animal Love Sock\n\nSoft, cute, and made to stick by your side (just like your favorite furry friends). With plush comfort and grippy support, the Animal Love grip sock is a perfect way to showcase your love for those loyal little sidekicks in every step, stretch, and snuggle. Grippy enough for staying put, steady enough for moving, and cute enough to make you smile.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• Extra stick + grip like the honeycomb\n• Arch support and terry cloth bottom for ultimate comfort\n• Lightweight, breathable, and moisture-wicking\n• Cutest prints: Dog and Cat\n• Machine washable\n• One size fits all",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:32.371Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
